'use client';

import React from 'react';
import { isEmpty } from 'lodash';

interface TooltipConfig {
  title: string;
  content: string[];
}

/**
 * 格式化 tooltip 内容, 目前用于 创建空间提示，个人积分提示，团队积分提示
 * @param config 包含title和content的配置对象
 * @returns JSX.Element | null
 */
const FormatTooltipContent = (config: TooltipConfig) => {
  const { title, content } = config;

  if (isEmpty(title) && isEmpty(content)) return null;

  return (
    <div className="flex flex-col w-50 p-2">
      {title && (
        <div className="font-bold mb-2 text-[white] text-[16px]">{title}</div>
      )}
      <div className="flex flex-col gap-2">
        {content?.map((item, index) => (
          <div key={index} className="flex text-[12px]">
            <div className="mr-2">•</div>
            <div className="flex-1">{item}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormatTooltipContent;
